import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface DigitProps {
  value: number;
  label: string;
}
function Digit({
  value,
  label
}: DigitProps) {
  return <div className="flex min-w-[40px] flex-col items-center" data-id="element-44" data-mp="3nk07ff2nfyrq">
      <span className="rounded-lg border border-teal-200 bg-white/80 px-2.5 py-1 text-lg font-black leading-none tabular-nums text-ink shadow-sm md:text-xl" data-id="element-45" data-mp="3nife1ss2mlvg">
        {String(value).padStart(2, '0')}
      </span>
      <span className="mt-1 text-[8px] font-bold uppercase tracking-[0.16em] text-ink/55" data-id="element-46" data-mp="f0vlnclph82">
        {label}
      </span>
    </div>;
}
export function CountdownBanner() {
  const {
    timeLeft,
    isExpired
  } = useCountdown();
  return <div className="w-full border-b border-teal-200 bg-teal-50 px-4 py-3" data-id="element-47" data-mp="f3xbu7ota0jr">
      {isExpired ? <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-3 sm:flex-row sm:gap-5" data-id="element-48" data-mp="k3joaewtfcri">
          <p className="text-center text-sm font-bold leading-snug text-ink sm:text-left md:text-base" data-id="element-49" data-mp="o4dddblzuxlz">
            Meeting With the Master: Advanced - Finally Fix Your Health &amp;
            Change Your Life
          </p>
          <a href="#advanced-price" className="inline-flex w-full items-center justify-center rounded-xl bg-emerald-600 px-6 py-3 text-sm font-black text-white shadow-[0_8px_20px_rgba(5,150,105,0.25)] ring-1 ring-emerald-500 transition-colors duration-200 hover:bg-emerald-700 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-emerald-300/50 sm:w-auto" data-id="element-50" data-mp="isgq9sg67l0x">
            Book Your Meeting
          </a>
        </div> : <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-3 sm:flex-row sm:gap-5" data-id="element-51" data-mp="wsj6zbcqs8el">
          <p className="text-center text-sm font-bold leading-snug text-ink sm:text-left md:text-base" data-id="element-52" data-mp="rswrswdcsi35">
            Finally Fix Your Health &amp; Change Your Life: Special Offer Expires
            In
          </p>
          <div className="flex items-start gap-2" role="timer" aria-label="Time remaining until the special offer expires" data-id="element-53" data-mp="1khtz64g10uh4">
            <Digit value={timeLeft.days} label="Days" data-id="element-54" data-mp="3jptu0m78q6xc" />
            <span className="mt-1 text-lg font-black text-ink/35" data-id="element-55" data-mp="3jrn64h0mhjcq">:</span>
            <Digit value={timeLeft.hours} label="Hrs" data-id="element-56" data-mp="3504pqi3upmsu" />
            <span className="mt-1 text-lg font-black text-ink/35" data-id="element-57" data-mp="39z7l1au14enm">:</span>
            <Digit value={timeLeft.minutes} label="Min" data-id="element-58" data-mp="39xedltbldqek" />
            <span className="mt-1 text-lg font-black text-ink/35" data-id="element-59" data-mp="2vz6m40xbrhas">:</span>
            <Digit value={timeLeft.seconds} label="Sec" data-id="element-60" data-mp="301thgbt7fkcq" />
          </div>
        </div>}
    </div>;
}